var map = {
	"./404-desktop.svg": 1200,
	"./404-mobile.svg": 1201,
	"./500-desktop.svg": 1202,
	"./500-mobile.svg": 1203,
	"./D-inverted.svg": 1204,
	"./D.svg": 658,
	"./adult.svg": 1205,
	"./bubble-holder.svg": 1144,
	"./check-mark.svg": 1206,
	"./content-marketing.svg": 1207,
	"./crown-black.svg": 659,
	"./crown-white.svg": 525,
	"./delfi-kp.svg": 1208,
	"./dplius-button.svg": 1209,
	"./dplius-white.svg": 1210,
	"./dplius.svg": 1211,
	"./icons/01d.svg": 660,
	"./icons/01n.svg": 661,
	"./icons/02d.svg": 662,
	"./icons/02n.svg": 663,
	"./icons/03d.svg": 664,
	"./icons/03n.svg": 665,
	"./icons/04d.svg": 666,
	"./icons/04n.svg": 667,
	"./icons/09d.svg": 668,
	"./icons/09n.svg": 669,
	"./icons/10d.svg": 670,
	"./icons/10n.svg": 671,
	"./icons/11d.svg": 672,
	"./icons/11n.svg": 673,
	"./icons/13d.svg": 674,
	"./icons/13n.svg": 675,
	"./icons/50d.svg": 676,
	"./icons/50n.svg": 677,
	"./icons/arrow-right.svg": 678,
	"./icons/color-01d.svg": 679,
	"./icons/color-01n.svg": 680,
	"./icons/color-02d.svg": 681,
	"./icons/color-02n.svg": 682,
	"./icons/color-03d.svg": 683,
	"./icons/color-03n.svg": 684,
	"./icons/color-04d.svg": 685,
	"./icons/color-04n.svg": 686,
	"./icons/color-09d.svg": 687,
	"./icons/color-09n.svg": 688,
	"./icons/color-10d.svg": 689,
	"./icons/color-10n.svg": 690,
	"./icons/color-11d.svg": 691,
	"./icons/color-11n.svg": 692,
	"./icons/color-13d.svg": 693,
	"./icons/color-13n.svg": 694,
	"./icons/color-50d.svg": 695,
	"./icons/color-50n.svg": 696,
	"./icons/color-outline-01d.svg": 697,
	"./icons/color-outline-01n.svg": 698,
	"./icons/color-outline-02d.svg": 699,
	"./icons/color-outline-02n.svg": 700,
	"./icons/color-outline-03d.svg": 701,
	"./icons/color-outline-03n.svg": 702,
	"./icons/color-outline-04d.svg": 703,
	"./icons/color-outline-04n.svg": 704,
	"./icons/color-outline-09d.svg": 705,
	"./icons/color-outline-09n.svg": 706,
	"./icons/color-outline-10d.svg": 707,
	"./icons/color-outline-10n.svg": 708,
	"./icons/color-outline-11d.svg": 709,
	"./icons/color-outline-11n.svg": 710,
	"./icons/color-outline-13d.svg": 711,
	"./icons/color-outline-13n.svg": 712,
	"./icons/color-outline-50d.svg": 713,
	"./icons/color-outline-50n.svg": 714,
	"./icons/colored_clearsky_night.svg": 715,
	"./icons/colored_cloudy.svg": 716,
	"./icons/colored_fog.svg": 717,
	"./icons/colored_partlycloudy_night.svg": 718,
	"./icons/colored_rain.svg": 719,
	"./icons/colored_snow.svg": 720,
	"./icons/colored_sun.svg": 721,
	"./icons/colored_sun_cloudy.svg": 722,
	"./icons/colored_thunder.svg": 723,
	"./icons/crown.svg": 526,
	"./icons/direction.svg": 724,
	"./icons/location.svg": 725,
	"./icons/not-available.svg": 726,
	"./icons/search.svg": 727,
	"./icons/small-01d.svg": 728,
	"./icons/small-01n.svg": 729,
	"./icons/small-02d.svg": 730,
	"./icons/small-02n.svg": 731,
	"./icons/small-03d.svg": 732,
	"./icons/small-03n.svg": 733,
	"./icons/small-04d.svg": 734,
	"./icons/small-04n.svg": 735,
	"./icons/small-09d.svg": 736,
	"./icons/small-09n.svg": 737,
	"./icons/small-10d.svg": 738,
	"./icons/small-10n.svg": 739,
	"./icons/small-11d.svg": 740,
	"./icons/small-11n.svg": 741,
	"./icons/small-13d.svg": 742,
	"./icons/small-13n.svg": 743,
	"./icons/small-50d.svg": 744,
	"./icons/small-50n.svg": 745,
	"./icons/thick_clearsky_night.svg": 746,
	"./icons/thick_cloudy.svg": 747,
	"./icons/thick_fog.svg": 748,
	"./icons/thick_partlycloudy_night.svg": 749,
	"./icons/thick_rain.svg": 750,
	"./icons/thick_snow.svg": 751,
	"./icons/thick_sun.svg": 752,
	"./icons/thick_sun_cloudy.svg": 753,
	"./icons/thick_thunder.svg": 754,
	"./icons/thin_clearsky_night.svg": 755,
	"./icons/thin_cloudy.svg": 756,
	"./icons/thin_fog.svg": 757,
	"./icons/thin_partlycloudy_night.svg": 758,
	"./icons/thin_rain.svg": 759,
	"./icons/thin_snow.svg": 760,
	"./icons/thin_sun.svg": 761,
	"./icons/thin_sun_cloudy.svg": 762,
	"./icons/thin_thunder.svg": 763,
	"./lock.svg": 1145,
	"./logos/delfi-plius.svg": 1212,
	"./logos/delfi.svg": 1213,
	"./logos/dsubscription-blue.svg": 764,
	"./logos/ekspress.svg": 1214,
	"./subscribed.svg": 1215,
	"./subscribed_ru.svg": 1216,
	"./tellUs.svg": 1217
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1199;